'use es6';

import { stripDuplicateClasses } from 'DesignData/lib/css'; // Surefire way to test for NaN in JS is by self comparison. Only thing in JS that doesn't equal itself.

/* eslint-disable no-self-compare */

const addCssClassNamePrefix = cx => `.${cx}`;

const createLookahead = term => `(?=.*${term}.*)`;
/**
 * Trims leading and trailing whitespace and forward slashes.
 */


export function trimSlashesAndWhitespace(str) {
  if (typeof str !== 'string') return '';
  str = str.trim();

  if (str[0] === '/') {
    str = str.replace(/^[\/\s]+/, '');
  }

  if (str[str.length - 1] === '/') {
    str = str.replace(/[\/\s]+$/, '');
  }

  return str;
}
/**
 * Format an asset path so that it can be used for reference comparisons.
 * @see {@link https://git.hubteam.com/HubSpot/DesignManagerUI/issues/4821#issuecomment-1200581}
 */

export function formatPathAsId(path) {
  path = typeof path === 'string' && path.toLowerCase() || '';
  path = path && trimSlashesAndWhitespace(path);
  if (!path) return '';
  path = path && decodeURIComponent(path);
  return `/${path}`;
}
export function toFileName(originalName) {
  if (typeof originalName !== 'string') return '';
  return originalName.trim().replace(/\s/g, '_').replace(/[^a-zA-Z0-9\-\._]/g, '');
}
export function toTitleCase(str, delimiter = ' ') {
  return str.split(delimiter).map(__part => __part.charAt(0).toUpperCase() + __part.slice(1)).join(delimiter);
}
export function toSnakeCase(str) {
  return str.toLowerCase().replace(/[^a-z0-9_]+/g, '_').replace(/^[\d_]+/, '');
}
export function toSlug(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
}
export function tryParseNumber(val) {
  const parsed = +val;
  return parsed === parsed ? parsed : val;
}
export function tryParseInt(val) {
  const parsed = parseInt(val, 10);
  return parsed === parsed ? parsed : val;
}
export function getPathPartsFromFullPath(fullpath) {
  const parts = fullpath.split('/');
  const name = parts.pop();
  const path = parts.join('/');
  return {
    fullpath,
    path,
    name
  };
}
export function stringifyQuery(query = {}) {
  return Object.keys(query).sort().map(key => `${key}=${query[key]}`).join('&');
}
export function createCssSelectorString(id, classes) {
  const cssId = id && id.replace(/\s+|#/g, ''); // Replace chars not allowed by classes with whitespace.
  // Allowed are alphanumeric chars, underscores, and hyphens.
  // Doing this to ensure we can split the input into an array.

  const cssClass = stripDuplicateClasses(classes && classes.replace(/[^\w-]/g, ' ').trim());
  let selector = '';

  if (cssId) {
    selector += `#${cssId}`;
  }

  if (cssClass) {
    selector += cssClass.split(/\s+/).map(addCssClassNamePrefix).join('');
  }

  return selector;
}
export function createSearchRegExp(searchTerm) {
  const expression = searchTerm.replace(/\(|\)|\[|\]/g, '').split(/\s+/).map(createLookahead).join('');
  return new RegExp(expression, 'i');
}
export function hasSearchMatch(searchRegExp, ...values) {
  return searchRegExp.test(values.join(' '));
}
export function toBoolean(string) {
  switch (string) {
    case 'true':
      return true;

    case 'false':
      return false;

    default:
      return !!string;
  }
}
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}